/**
 * @description 服务
 */

import axios from 'axios'
import {Api} from '../api/'
import config from '../config'
import {timeString, getMonthBefor, getDate, timeStringArr} from '../utils/'
import sha1 from 'crypto-js/sha1'
import sessionExpectionFilter from './sesstionFilter'

import Vue from 'vue'
// axios活动太过火爆拦截提示
axios.interceptors.response.use(res => {
  if (res.status === 403) {
    Vue.$toast('活动太火爆，请稍后再试')
  }
  return res
})

// 需要拦截登录失效的axios实例
const _axios = axios.create()
_axios.interceptors.response.use(sessionExpectionFilter)

Object.assign = Object.assign || function (e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t]
    for (var i in n) {
      Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i])
    }
  }
  return e
}

// 默认超时时间
axios.defaults.timeout = 30000

/**
 * @description 请求广告
 */

export function getAds(options) {
  let params = {
    pos: config.orderSuccessAdCode,
    w: config.orderSuccessAdW,
    h: config.orderSuccessAdH
  }
  params = Object.assign({}, params, {
    model: 303,
    client: config.clientVersionId,
    channel: config.channelId
  }, options)
  return axios.get(Api.ads, {params: params})
}

/**
 * @desc 获取常见问题
 * @params faqCode
 */
export function getFaqs({faqCode, msgNum = 1}) {
  if (!faqCode) {
    return
  }
  return axios.get(Api.msg, {params: {cateCode: faqCode, msgNum: msgNum}})
}

/**
 * 获取营销系统商品列表
 * clientId  是  客户端ID  运营配置后生成。
 * userId  否  用户ID
 * authId  否  认证ID  例如：建行活动加密串
 * authType  否  用户认证类型：
 * FZS 蜂助手  默认FZS
 *  schemeNo  是  方案编号  方案编号，后台配置后生成，前端根据后台方案配置生成的方案编号获取任务方案；
 * skuIds  否  单品Ids  可传多个，以逗号隔开
 */
export function getSkuList({userId, authType, schemeNo, clientId}) {
  return axios.post(Api.skuList, {
    clientId: clientId || config.clientVersionId
    , userId
    , authType
    , schemeNo
  })
}

/**
 * 预估佣金批量查询
 * skuList: [] 单品信息列表必填
 * entityTypeCode 商品类型编码
 * salePrice 单品售价
 * skuId  单品id
 */
export function getBatchCommission({skuList, clientId}) {
  return axios.post(Api.commission, {
    clientId: clientId || config.clientVersionId
    , skuList
  })
}

/**
 * 获取授权优惠券列表（卡券中心）
 * authCode 授权码
 * authToken 用户登录后的token 传入authtoken后，会校验用户是否可领取优惠券
 * clientId 客户端ID
 */
export function getAuthCoupon({authToken, clientId}) {
  return axios.get(Api.getAuthCoupon, {params: {clientId: clientId || config.clientVersionId, authCode: config.authCode, authToken}})
}

/**
 * 领取优惠券 --- authken
 * authCode授权码必填
 * authToken用户登录后的token必填
 * clientId客户端ID必填
 * couponCode优惠券编码必填
 */
export function receiveCoupon({authToken, couponCode, clientId}) {
  return _axios.get(Api.receivecoupon, {
    params: {
      authCode: config.authCode,
      authToken,
      clientId: clientId || config.clientVersionId,
      couponCode: couponCode || config.openCouponCode
    }
  })
}

/**
 * @desc 获取商品详情
 * @param categoryId
 * @param phone
 * @returns {*}
 */
export function getProductdetail({productId, userId, clientId, channelId}) {
  return axios.get(Api.productdetail, {
    params: {
      productId: productId, // 目录id
      clientId: clientId || config.clientVersionId, // 客户端Id
      channelId: channelId || config.channelId, // 渠道Id
      userId: userId // 登录用户、会员用户价格不一样
    }
  })
}

export function getFzsPlus({authToken}) {
  return axios.get(Api.judgePlus, {
    headers: {'X-Requested-With': 'XMLHttpRequest'},
    params: {
      authToken
    }
  })
}

/**
 * @desc 获取加密签名
 * @param appSecret
 * @param appKey
 * @param data
 * @param timestamp
 * @returns {string}
 * @private
 */
function _getSign({appSecret, appKey, data, timestamp}) {
  return sha1(appSecret + 'appKey' + appKey + 'bizContent' + JSON.stringify(data) + 'timestamp' + timestamp + appSecret).toString().toUpperCase()
}

/**
 * @desc 下单接口
 * @param skuId 商品ID
 * @param channelSkuId 商品ID
 * @param num 购买数量
 * @param ext
 * @param payMethodCode 支付方式ID
 * @param invoice 发票信息
 * @returns {*|AxiosPromise<any>}
 * marketing  营销扩展参数  object
 * authToken  下单用户token  string  营销配置需要校验用户信息时必填
 * authType  下单用户授权类型  string  必填
 * cyAuthToken  分享人token  string  有分享人且营销配置校验参与者时必填
 * cyAuthType  分享人授权类型  string  有分享人时，必填
 * cyUserId  分享人用户id  string  有分享人且营销配置无需校验参与者时必填
 * userId  下单用户id  string  有分享人且营销配置校验参与者时必填
 */
export function submit({skuId, channelSkuId, channelAccount, payMethodSubCode, num, ext, payMethodCode, payReturnUrl, unpayReturnUrl, coupons, invoice, userId, authToken, otherProperties, appId, channelAccountType, clientVersionId, channelId}) {
  let data = {
    client: {
      clientVersionId: clientVersionId || config.clientVersionId,
      clientVersionNo: config.clientVersionNo,
      clientType: '',
      deviceId: '',
      deviceCode: '',
      deviceBrand: '',
      deviceType: '',
      position: '',
      positionName: '',
      srcType: '',
      srcObjectId: ''
    },
    order: {
      orderItems: [{
        skuId: skuId,
        channelSkuId: channelSkuId || '',
        num: num,
        ext: ext
      }],
      appId: appId || config.appId, // SDK支付需要传
      payMethodCode: payMethodCode,
      payMethodSubCode: payMethodSubCode, // 子支付方式code
      payReturnUrl: payReturnUrl,
      unpayReturnUrl: unpayReturnUrl,
      loginUserId: userId || config.userId,
      loginStaffId: '',
      channelOrderNo: '',
      channelId: channelId || config.channelId,
      channelAccount: channelAccount
      , channelAccountType
    },
    // 优惠券信息
    coupons: coupons
    ||
    [],
    srcType:
    config.srcType,
    otherProperties
  }
  if (otherProperties) {
    data.otherProperties = JSON.stringify(Object.assign(otherProperties, {
      // 推荐人活动ID
      refereeActivityId: config.refereeActivityId,
      // 被推荐人活动Id
      applicantActivityId: config.applicantActivityId,
      // 任务ID
      task_no: config.task_no,
      // 方案编号
      schemeNo: config.schemeNo
    }))
  }
  if (config.srcType) {  // 'physical' // 实物订单
    data.srcType = config.srcType
  }
  // 发票信息
  invoice && (data.invoice = invoice)
  let sign = _getSign({
    appSecret: config.appSecret,
    appKey: config.appKey,
    data: data,
    timestamp: timeString()
  })
  let url = Api.placeorder + '?authToken=' + authToken + '&sign=' + sign + '&appKey=' + config.appKey + '&timestamp=' + timeString()
  return axios.post(url, data)
}

/**
 * @desc 查询订单记录
 * @param orderTarget 订单交易对象。比如充值手机号，加油卡卡号，电表号。如果未登录，则要求必填。
 * @param authToken 用户token
 * @param productType 商品类别编码
 * @param productName 商品名称
 * @param offset 起始数
 * @param pageSize 一次查询数量
 * @returns {*|AxiosPromise<any>}
 */
export function searchRecord({authToken, loginUserId, offset, pageSize}) {
  let data = {
    loginUserId: loginUserId,
    clientVersionId: config.clientVersionIds || config.clientVersionId, // 支持查多个客户端
    startTime: getMonthBefor(),
    endTime: getDate(),
    statusCode: '',
    offset: offset,
    pageSize: pageSize,
    productType: config.productType,
    orderBusinessType: config.orderBusinessType,
    ver: '3'
  }
  let sign = _getSign({
    appSecret: config.appSecret,
    appKey: config.appKey,
    params: data,
    timestamp: timeString()
  })
  let url = Api.userorderlist + '?authToken=' + authToken + '&sign=' + sign + '&appKey=' + config.appKey + '&timestamp=' + timeString()
  return _axios.post(url, data)
}

/**
 * @desc 查询订单状态
 * @param orderId 订单ID
 * @returns {*|AxiosPromise<any>}
 */
export function getRecordState({orderId, authToken, userId}) {
  let data = {
    loginUserId: userId,
    loginStaffId: '',
    orderId: orderId,
    ver: '2'
  }
  let sign = _getSign({
    appSecret: config.appSecret,
    appKey: config.appKey,
    data: data,
    timestamp: timeString()
  })
  let url = Api.userorderState + '?authToken=' + authToken + '&sign=' + sign + '&appKey=' + config.appKey + '&timestamp=' + timeString()
  return _axios.post(url, data)
}

// 微信授权后，根据token获取其他用户信息
export function	behalfRecord({orderId}) {
  return axios.get(Api.behalfRecord, {
    params: {
      orderId
      // orderId: '70de0532e5ad4bf5bf9f7d2207653939'
    }
  })
}

/**
 * @desc 查询订单详情
 * @param orderId 订单ID
 * @returns {*|AxiosPromise<any>}
 */
export function getRecordDetail({tradeId, authToken}) {
  let params = {
    tradeId
  }
  let sign = _getSign({
    appSecret: config.appSecret,
    appKey: config.appKey,
    params: params,
    authToken: authToken,
    timestamp: timeString()
  })
  let url = Api.userorderdetail + '?authToken=' + authToken + '&sign=' + sign + '&appKey=' + config.appKey + '&timestamp=' + timeString()
  return _axios.post(url, params)
}

// 激活优惠券
export function checkCoupon(options) {
  return axios.post(Api.checkCoupon, options)
}

/**
 * @description 根据商品信息获取合法可用的优惠券
 * @param options object 包含如下：
 * data: {authToken, productCode(商品编码), productTypeCode(商品类型编码), capacity(商品数量), price(商品单价), orderFee(订单金额), clientId, isPromotion (促销商品:1是0否。没有默认0)}
 * @return {Promise}
 */
export function getCouponWithProductInfo(options) {
  return _axios.post(`${Api.getCouponWithProduct + '?authToken=' + options.authToken}`, options)
}

/**
 * @description 获取商品可领取的优惠券
 * @param authCode 授权码
 */
export function getAvaliableCouponList({userId, productTypeCode, clientId, productId, authCode, authType}) {
  return axios.get(Api.getProductAvaliableCoupon, {params: {userId, productTypeCode, clientId, productId, authCode, authType}})
}

/**
 * @description 获取商品可领取的优惠券-带authken
 * @param authCode授权码必填
 * @param authTokentoken
 * @param authType授权类型必填
 * @param clientId客户端ID必填
 * @param productId商品ID
 * @param productTypeCode商品类型，支持多个，用英文逗号隔开
 * @param skuId
 */
export function getReceiveuseCouponNewList({authToken, productTypeCode, clientId, productId, authCode, authType}) {
  return axios.get(Api.getReceiveuseCouponNew, {
    params:
      {authToken, productTypeCode, clientId, productId, authCode, authType}
  })
}

/**
 * @description 获取活动列表
 * @param 活动栏目ID
 */
export function getActivity(cat) {
  return axios.get(Api.activityApi, {
    params: {
      cat: cat,
      clientVersionId: config.clientVersionId,
      clientVersionNo: config.clientVersionNo,
      offset: 0,
      pageSize: 10
    }
  })
}

/**
 * @description 登记活动
 */
export function registerAcitivty(options) {
  return axios.get(Api.registerActivity, {
    params: {
      authToken: options.authToken || config.authToken,
      clientVersionId: options.clientVersionId || config.clientVersionId,
      clientVersionNo: options.clientVersionNo || config.clientVersionNo,
      playerId: options.playerId, //
      activityId: options.activityId,
      certId: options.certId, // 销售订单Id
      prodCode: options.prodCode, // 产品编码
      mobile: options.mobile // 用户手机号码
    }
  })
}

/**
 * 活动 收集用户行为
 * actionParams  行为参数  object
 * actionNo  行为编号  string  从任务列表获取，或者根据后台配置固定。@mock=ACT_SXYUDGOZ
 * authType  用户类型  string  产品指定。@mock=PHONE_NV1
 * clientId  客户端ID  string  产品指定。@mock=2
 * userId  用户ID  string  用户ID。@mock=Nt1VcQH2ENu7HXYplN%2FlX9c
 * voucherParams  凭证参数  object  该参数根据行为定义编码去不同的业务系统校验行为有效性；
 * voucherKey  凭证参数VALUE    枚举值如下：orderId，商品交易等行为传订单ID；phone，领权益抽奖等行为。。@mock=orderId
 * voucherValue  凭证参数KEY    订单id或手机号等。。@mock=15902071082
 * */
export function collectUserAction({authToken, userId, voucherValue, clientId, actionNo}) {
  let data = {
    actionParams: {
      actionNo: config.actionNo || actionNo
    }
    , ext: JSON.stringify({
      myAuthToken: authToken
    })
    , authType: config.authType
    , clientId: clientId || config.clientVersionId
    , userId
  }
  if (voucherValue) {
    data.voucherParams = {
      voucherKey: 'orderId'
      , voucherValue
    }
  }
  return _axios.post(`${Api.collectUserAction}?authToken=${authToken}`, data)
}

/**
 * 领取用户奖品
 * authType: "BZCZZX"
 * clientId: "287"
 * orderId: "e4cab4dedd15435084cfd363eb2e4678"
 * userId: 292150
 * */
export function receiveUserPrize({authToken, userId, orderId, clientId}) {
  return _axios.post(`${Api.receiveUserPrize}?authToken=${authToken}`, {
    authType: config.authType
    , clientId: clientId || config.clientVersionId
    , userId
    , orderId
  })
}


/**
 * 获取短信验证码
 */
export function sendSmsCode({phonenum, validCode, modelid = config.modelId, templateid = config.templateId, key}) {
  return axios.get(Api.sendsmscode, {params: {phonenum, validCode, modelid, templateid, key}})
}

/**
 * 一键登录
 */
export function authLogin(options) {
  let data = {
    // 客户端ID
    clientVersionId: config.clientVersionId,
    // 注册来源
    registerFrom: config.registerFrom,
    // 渠道ID
    channelId: config.channelId,
    // 拓展信息
    extendInfo: {
      extendType: 'SMS',
      // 短信组件id
      modelid: config.modelId,
      // 短信模板id
      templateid: config.templateId,
      // 短信验证码
      smsValiCode: ''
    },
    // 手机号码
    mobile: '',
    // 登录类型;1,手机号+验证码;2,移动登录;3,微信公众号登录;4,微信小程序登录
    loginType: 1
  }
  return axios.post(Api.authloginV2, Object.assign({}, data, options))
}


/**
 * 下单前获取可用的优惠券
 * userId: '', // 用户ID
 clientId: config.clientVersionId, // 客户端ID
 orderFee: '', // 订单总金额
 authType: '',// 授权类型
 productList: [{
      skuId: '',// 单品ID
      productId: '',// 商品ID
      productTypeId: '',// 商品类型ID
      isPromotion: '',// 是否促销商品, 1是，0否
      capacity: '',// 单品数量
      price: '',// 单品下单价格
      skuFee: '',// 单品总金额
    }], // 商品列表
 */
export function getValidCoupon(options) {
  return axios.post(Api.getvalidcoupon, options)
}

/**
 * 查询邀请码接口
 */
export function queryCode({authToken}) {
  return axios.get(Api.queryCode, {
    params: {
      authToken
    }
  })
}

/**
 * @description 取消订单
 */
export function closeOrder({authToken, orderNo}) {
  return _axios.get(Api.closeOrder, {
    params: {
      authToken,
      orderNo
    }
  })
}

/**
 * @description 删除订单
 */
export function removeOrder({authToken, orderNo}) {
  return _axios.get(Api.removeOrder, {
    params: {
      authToken,
      orderNo
    }
  })
}

/**
 * @description 获取支付方式---二次支付
 */
export function getPayMethods({orderNo}) {
  return axios.get(Api.getPayMethods, {
    params: {
      orderNo
    }
  })
}

/**
 * 二次支付
 * orderNo 订单编号
 * pay 支付方式相关
 * pay
 * appId app采用sdk支付时需要传入
 * payMethodCode是支付类型。比如（支付宝：ALIPAY、微信：WXPAY、金币：GOLD_PAY）。
 * payMethodSubCode是支付方式。比如（支付宝APP支付：ALIPAY_SDK、微信APP支付：WXPAY_SDK、金币支付：GOLD_PAY）。
 * fqNum否花呗分期使用
 * payReturnUrl是支付成功跳转到此地址
 * unpayReturnUrl是支付失败跳转到此地址
 */
export function secondPay({orderNo, pay}) {
  return axios.post(Api.secondPay, {
    orderNo,
    pay: Object.assign({}, {
      appId: config.appId // SDK支付需要传
    }, pay)
  })
}

export function getAuthTokenByTicket({code, unionId, authTokenTicket}) {
  return axios.post(Api.getAuthTokenByTicket, {
    code,
    unionId,
    authTokenTicket
  })
}

export function getUserInfo({authToken}) {
  return axios.get(Api.userInfo, {
    params: {
      authToken
    }
  })
}

/**
 * 1.3.查询银行卡信息
 * */
export function getBankCard({authToken}) {
  return _axios.get(Api.queryBankCard, {
    params: {
      authToken
    }
  })
}

/**
 * 获取建行支付钱包短信验证码
 */
export function sendCbcPaySmsCode({
                                    authToken,
                                    clientId = config.clientVersionId,
                                    consumer_code = config.consumerCode,
                                    entityTypeId,
                                    method = 'smscode',
                                    paymentSubMethodId,
                                    payType,
                                    version = '1.0'
                                  } = {}) {
  let [timestr, timestamp] = timeStringArr(true)
  let sign = sha1(`consumer_code=${consumer_code}&method=${method}&request_no=${timestamp}&timestamp=${timestr}&version=${version}${config.prodKey}`).toString().toUpperCase()
  return _axios.post(Api.sendCbcPaySmsCode, {
    authToken,
    clientId,
    consumer_code,
    entityTypeId,
    method,
    paymentSubMethodId,
    payType,
    version,
    sign,
    request_no: timestamp,
    timestamp: timestr
  })
}
export function buyBeforePoint ({ clientId, channelId,  userId, productId, guid }) {
  return axios.get(Api.buyBeforePoint, {
    params: {clientId, channelId, userId, productId, guid}
  })
}
export function jumpHomeBeforePoint ({ clientId, channelId, userId, productId }) {
  return axios.get(Api.jumpHomeBeforePoint, {
    params: {clientId, channelId, userId, productId}
  })
}
export function errorReport ({ clientId, channelId, guid, errorInfo }) {
  return axios.get(Api.errorReport, {
    params: {clientId, channelId, guid, errorInfo}
  })
}
export function detailLoadComplete ({ userId, channelId, productId, clientId }) {
  return axios.get(Api.detailLoadComplete, {
    params: {clientId, channelId, userId, productId}
  })
}

// 刷新token
export function getSycnUserInfo ({authToken}){
  return axios.get(Api.sycnUserInfo, {
    params: {
      authToken: authToken
    }
  })
}